/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Measurement } from './measuring-tool/measurement.model';
import { RangeRingPoint } from './range-rings/range-ring.model';

export enum ToolsPanelViewState {
  MENU = 'tools-menu',
  MEASURING_TOOL = 'measuring-tool',
  NEARBY_VESSELS = 'nearby-vessels',
  RANGE_RINGS = 'range-rings',
  WEATHER = 'weather',
}

interface ToolsPanelState {
  viewState: ToolsPanelViewState;
  rangeRings: {
    points: RangeRingPoint[];
  };
  measuringTool: {
    measurements: Measurement[];
  };
  shippingTrafficV2Opacity: number;
  shippingTrafficV2Checked: boolean;
  shippingTrafficLayerExists: boolean;
}

export const INITIAL_TOOLS_PANEL_STATE: ToolsPanelState = {
  viewState: ToolsPanelViewState.MENU,
  rangeRings: {
    points: [],
  },
  measuringTool: {
    measurements: [],
  },
  shippingTrafficV2Opacity: 100,
  shippingTrafficV2Checked: false,
  shippingTrafficLayerExists: false,
};

const ToolsPanelSlice = createSlice({
  name: 'tools',
  initialState: INITIAL_TOOLS_PANEL_STATE,
  reducers: {
    setToolsPanelViewState: (
      state,
      action: PayloadAction<ToolsPanelState['viewState']>
    ) => {
      state.viewState = action.payload;
    },
    setRangeRingPoints: (state, action: PayloadAction<RangeRingPoint[]>) => {
      state.rangeRings.points = action.payload;
    },
    setMeasurements: (state, action: PayloadAction<Measurement[]>) => {
      state.measuringTool.measurements = action.payload;
    },
    setShippingTrafficV2Opacity: (state, action) => {
      state.shippingTrafficV2Opacity = action.payload;
    },
    setShippingTrafficV2Checked: (state, action) => {
      state.shippingTrafficV2Checked = action.payload;
    },
    setShippingTrafficLayerExists: (state, action) => {
      state.shippingTrafficLayerExists = action.payload;
    },
  },
});

export const {
  setToolsPanelViewState,
  setRangeRingPoints,
  setMeasurements,
  setShippingTrafficV2Opacity,
  setShippingTrafficV2Checked,
  setShippingTrafficLayerExists,
} = ToolsPanelSlice.actions;

export default ToolsPanelSlice.reducer;
